<template>
    <a-card type="inner" size="small">
        <a-skeleton :loading="preload" active>
            <a-form :form="form" :layout="formLayout" @submit="handleSubmit">
                <a-divider dashed orientation="left">Informasi WOM</a-divider>

                <a-form-item label="Modul">
                    <a-select
                        v-decorator="[
                            'module',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Pilih modul'
                                    }
                                ]
                            }
                        ]"
                        placeholder="Pilih Modul"
                    >
                        <a-select-option key="classical" value="classical">
                            Klasikal
                        </a-select-option>
                        <a-select-option key="paper" value="paper">
                            Makalah
                        </a-select-option>
                        <a-select-option key="project" value="project">
                            Project Management
                        </a-select-option>
                        <a-select-option key="performance" value="performance">
                            Performance
                        </a-select-option>
                        <a-select-option key="evaluation" value="evaluation">
                            Evaluasi
                        </a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="Tipe">
                    <a-select
                        v-decorator="[
                            'type',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Pilih tipe'
                                    }
                                ]
                            }
                        ]"
                        placeholder="Pilih Tipe"
                    >
                        <a-select-option key="classical" value="classical">
                            Klasikal
                        </a-select-option>
                        <a-select-option key="percentage" value="percentage">
                            Persentasi
                        </a-select-option>
                        <a-select-option key="question" value="question">
                            Pertanyaan
                        </a-select-option>
                        <a-select-option key="depth" value="depth">
                            Kedalaman
                        </a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="Nilai Minimum">
                    <a-input-number
                        :min="0"
                        v-decorator="[
                            'min_score',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Field ini wajib diisi'
                                    }
                                ]
                            }
                        ]"
                    >
                    </a-input-number>
                </a-form-item>

                <a-form-item label="Nilai Maksimum">
                    <a-input-number
                        :min="0"
                        v-decorator="[
                            'max_score',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Field ini wajib diisi'
                                    }
                                ]
                            }
                        ]"
                    >
                    </a-input-number>
                </a-form-item>

                <a-form-item label="Keterangan">
                    <a-input
                        placeholder="Keterangan"
                        v-decorator="[
                            'title',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Field ini wajib diisi'
                                    }
                                ]
                            }
                        ]"
                    >
                    </a-input>
                </a-form-item>

                <a-form-item label="Hexa">
                    <a-row type="flex">
                        <a-col>
                            <a-input
                                placeholder="Contoh: #34EB3A "
                                v-decorator="[
                                    'hex',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Field ini wajib diisi'
                                            }
                                        ]
                                    }
                                ]"
                            >
                            </a-input>
                        </a-col>
                    </a-row>
                    <a-row type="flex">
                        <a-col >
                            <i>Referensi kode warna Hex klik
                            <a-button type="link" href="https://htmlcolorcodes.com/" target="_blank">
                                disini
                            </a-button>
                            </i>
                        </a-col>
                    </a-row>
                </a-form-item>

                <a-form-item label="Rating">
                    <a-input
                        placeholder="Rating"
                        v-decorator="[
                            'rating',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Field ini wajib diisi'
                                    }
                                ]
                            }
                        ]" v-on:keypress="isLetter($event)"
                    >
                    </a-input>
                </a-form-item>

                <a-form-item label="Order">
                    <a-input-number
                        :min="0"
                        v-decorator="[
                            'order',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Field ini wajib diisi'
                                    }
                                ]
                            }
                        ]"
                    >
                    </a-input-number>
                </a-form-item>

                <a-form-item>
                    <a-row type="flex" justify="center" align="top">
                        <a-col>
                            <a-space>
                                <a-button
                                    type="primary"
                                    html-type="submit"
                                    :loading="processing"
                                    :disabled="processing"
                                    >Submit</a-button>
                                <a-button
                                    @click="handleClose"
                                    :loading="processing"
                                    :disabled="processing"
                                    >Tutup</a-button>
                            </a-space>
                        </a-col>
                    </a-row>
                </a-form-item>
            </a-form>
        </a-skeleton>
    </a-card>
</template>

<script>
export default {
    props: {
        layout: {
            type: Object,
            default: function() {
                return {
                    label: 6,
                    wrapper: 16
                };
            }
        },
        wom: {
            type: String,
            default: ""
        }
    },
    created() {
        if (this.editing) {
            this.preload = true;
            this.getItem();
        }
    },
    computed: {
        editing() {
            return this.wom !== "";
        }
    },
    data() {
        return {
            formLayout: 'horizontal',
            form: this.$form.createForm(this),
            preload: false,
            processing: false,
            item: {}
        };
    },
    methods: {
        getItem() {
            this.$http
                .get(
                    this.routeUri("api.wom.show", {
                        wom: this.wom
                    })
                )
                .then(res => (this.item = res.data))
                .finally(() => (this.preload = false));
        },
        handleSubmit(e) {
            e.preventDefault(e);

            this.form.validateFields((err, formData) => {
                if (!err) {
                    this.processing = true;

                    let promise;

                    if (this.editing) {
                        promise = this.$http.put(
                            this.routeUri("api.wom.update", {
                                wom: this.wom
                            }),
                            formData
                        );
                    } else {
                        promise = this.$http.post(
                            this.routeUri("api.wom.store"),
                            formData
                        );
                    }

                    promise
                        .then(response =>
                            this.handleSuccessResponse(response.data)
                        )
                        .catch(error =>
                            this.handleResponseError(error.response.data)
                        )
                        .finally(() => (this.processing = false));
                }
            });
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });
            setTimeout(() => this.$emit("handleClose", true), 2000);
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        handleClose() {
            this.$emit("handleClose", false);
        },
        isLetter(e) {
            let char = String.fromCharCode(e.keyCode); // Get the character
            if(/^[A-Za-z]+$/.test(char)) return true; // Match with regex 
            else e.preventDefault(); // If not match, don't add to input text
        }
    },
    watch: {
        item: function(value) {
            this.form.getFieldDecorator("title", { initialValue: value.title });
            this.form.getFieldDecorator("module", { initialValue: value.module });
            this.form.getFieldDecorator("type", { initialValue: value.type });
            this.form.getFieldDecorator("min_score", { initialValue: value.min_score });
            this.form.getFieldDecorator("max_score", { initialValue: value.max_score });
            this.form.getFieldDecorator("hex", { initialValue: value.hex });
            this.form.getFieldDecorator("rating", { initialValue: value.rating });
            this.form.getFieldDecorator("order", { initialValue: value.order });
        }
    }
};
</script>


